// import { createApp } from 'vue'
// import App from './App.vue'
// import router from './router'
// const app = createApp(App)
// app.use(router)
// app.mount('#app')

// import VantGreen from 'vant-green';
// import './style/index.css';

// Vue.use(VantGreen);

import Vue from 'vue';
import App from './App.vue';
import router from './router';
// import iView from 'iview';
// import 'iview/dist/styles/iview.css';
import Vant from 'vant';
import 'vant/lib/index.css';
import './style/index.css';
import preventPageZoom from './utils/prevent-zoom';

Vue.use(Vant);
// Vue.use(iView);

// 禁止页面被放大（双指缩放 / 双击放大）
preventPageZoom();

// import MintUI from 'mint-ui'
// import 'mint-ui/lib/style.css'
// Vue.use(MintUI);

new Vue({
  components: { App },
  router,
  template: '<App/>',
}).$mount('#app');
